import { Channel } from '@n2-common/serverGeneratedTypings/channel';
import { createContext, useContext, useMemo } from 'react';

export type UiContextProps = { channel: Channel; versionApp: string };

export const UiContext = createContext<UiContextProps | null>(null);

export function useUiContext(): UiContextProps {
    const res = useContext(UiContext);
    if (res === null) {
        // TODO: Remove this line when the context is used in all components
        return { channel: Channel.Web, versionApp: '' };
        // throw new Error('useIdContext hook is only allowed to be used nested under a UiContext.Provider.');
    }
    return res;
}

export function UiContextProvider({ children, channel, versionApp }: UiContextProps & React.PropsWithChildren) {
    const values = useMemo(
        () => ({
            channel,
            versionApp,
        }),
        [channel, versionApp]
    );
    return <UiContext.Provider value={values}>{children}</UiContext.Provider>;
}
